export default "__VITE_ASSET__DYdNxzBN__"